export default [{
  path: '/admin/apply/distribution/distributor/list',
  name: 'distributionDistributorList',
  component: () => import('@/views/apply/distribution/distributor/index'),
  meta: {
    title: '分销商管理',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/application/list',
  name: 'distributionApplicationList',
  component: () => import('@/views/apply/distribution/application/index'),
  meta: {
    title: '分销审核',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/level/list',
  name: 'distributionLevelList',
  component: () => import('@/views/apply/distribution/level/index'),
  meta: {
    title: '分销等级',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/config/index',
  name: 'distributionConfig',
  component: () => import('@/views/apply/distribution/config/index.vue'),
  meta: {
    title: '分销配置',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/upgrade_log/list',
  name: 'distributionUpgradeLog',
  component: () => import('@/views/apply/distribution/upgrade_log/index.vue'),
  meta: {
    title: '升级日志',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/distribution/commission/list',
  name: 'distributionCommissionList',
  component: () => import('@/views/apply/distribution/commission/index.vue'),
  meta: {
    title: '分销订单',
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/distribution.js